import React from 'react'
import Box from '../Box'
import LoginLayout from '../LoginLayout'
import { t as i18n } from 'ttag'
import { Button, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/styles'

const styles = theme => ({
  accountLocked: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(4)
  },
  text: {
    marginTop: theme.spacing(2)
  },
  buttonsContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
})

const AccountLocked = ({ classes }) => {
  const onClickBackToLogin = () => {
    window.history.back()
  }

  return (
    <LoginLayout>
      <Box headerTitle={i18n`Account locked`} enableLinks={false}>
        <div id='AccoutLocked-container' className={classes.accountLocked}>
          <Typography
            align={'center'}
            variant='subtitle1'
            color='textSecondary'
          >
            {i18n`Your account does not have permission to access the application.`}
          </Typography>
          <Typography
            className={classes.text}
            align={'center'}
            variant='subtitle1'
            color='textSecondary'
          >
            {i18n`Please contact your administrator.`}
          </Typography>

          <div className={classes.buttonsContainer}>
            <Button
              data-qid={'Button-backToLogin'}
              variant='contained'
              color='primary'
              onClick={onClickBackToLogin}
            >
              {i18n`Back to Login`}
            </Button>
          </div>
        </div>
      </Box>
    </LoginLayout>
  )
}

export default withStyles(styles)(AccountLocked)
